import { render, staticRenderFns } from "./mercadolibre_v2.vue?vue&type=template&id=628c8a68"
import script from "./mercadolibre_v2.vue?vue&type=script&lang=js"
export * from "./mercadolibre_v2.vue?vue&type=script&lang=js"
import style0 from "./mercadolibre_v2.vue?vue&type=style&index=0&id=628c8a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports